// Lead sources on the KPI page: leads by where they came from and how they made contact (decision D8), for the clients
// and agency picked above. Supabase (dashboard_source_matrix) counts each lead once, by its first interaction; managers
// and clients are refused there. A source opens Consolidated leads with the same source and dates.
import {useEffect,useRef,useState} from 'react';
import {supabase} from './supabase';
import {portalError} from './portal-model';
import {pageHref} from './page-link';
import {count} from './business-kpis-model';
import {matrixColumns,matrixGroups,matrixShare,type SourceMatrix as Matrix} from './source-matrix-model';

const periods=[[7,'Last 7 days'],[30,'Last 30 days'],[90,'Last 90 days']] as const;

/** clientsKey changes when the pick does; clients itself is a new array on every render. */
export function SourceMatrix({agency,clients,clientsKey,ready}:{agency:string;clients:string[]|null;clientsKey:string;ready:boolean}){
 const [days,setDays]=useState(30),[data,setData]=useState<Matrix|null>(null),[busy,setBusy]=useState(true),[error,setError]=useState('');
 const sequence=useRef(0);
 useEffect(()=>{if(!ready)return;const n=++sequence.current;setBusy(true);setError('');
  void Promise.resolve(supabase.rpc('dashboard_source_matrix',{p_days:days,p_agency:agency||null,p_clients:clients})).then(r=>{
   if(n!==sequence.current)return;if(r.error)setError(portalError(r.error));else setData(r.data as Matrix);setBusy(false);});
  return()=>{sequence.current++;};},[days,agency,clientsKey,ready]);
 const columns=data?matrixColumns(data):[];
 return <section className="bkpi-section" aria-labelledby="bkpi-sources" aria-busy={busy}>
  <div className="bkpi-section__head"><h3 id="bkpi-sources">Lead sources</h3>
   <p>Each lead once, by its first contact. Paid: an ad click, or a call to an ad’s number. Business Profile: a call to a Business Profile number. Website: anything else through our sites or their numbers.</p>
   <label className="bkpi-period">Period<select value={days} onChange={e=>setDays(Number(e.target.value))}>{periods.map(([d,l])=><option key={d} value={d}>{l}</option>)}</select></label></div>
  {error&&<p role="alert" className="form-error">{error}</p>}
  {!data&&busy&&<p role="status">Loading lead sources…</p>}
  {data&&<div className="table-wrap bkpi-table bkpi-matrix" tabIndex={0} role="region" aria-label="Lead sources by contact method"><table><thead><tr>
   <th scope="col">Source</th>{columns.map(c=><th scope="col" key={c.key}>{c.label}{!c.live&&<small>Not live yet</small>}</th>)}<th scope="col">Total</th><th scope="col">Share</th>
  </tr></thead>
  {matrixGroups(data).map(g=><tbody key={g.channel}>
   <tr className="bkpi-matrix__group"><th scope="rowgroup" colSpan={columns.length+3}>{g.label} · {count(g.total)} · {matrixShare(g.total,data.total)}%</th></tr>
   {g.rows.map(r=><tr key={r.key}>
    <th scope="row"><a href={pageHref('leads',{inq_source:r.key,inq_start:data.from_date,inq_end:data.to_date})}>{r.label}</a></th>
    {columns.map(c=><td key={c.key} className={c.live?undefined:'bkpi-matrix__off'}>{c.live?count(r[c.key]):'—'}</td>)}
    <td><strong>{count(r.total)}</strong></td><td>{matrixShare(r.total,data.total)}%</td>
   </tr>)}
  </tbody>)}
  <tfoot><tr><th scope="row">All leads</th>{columns.map(c=><td key={c.key} className={c.live?undefined:'bkpi-matrix__off'}>{c.live?count(c.total):'—'}</td>)}<td><strong>{count(data.total)}</strong></td><td>100%</td></tr></tfoot>
  </table></div>}
 </section>;
}
